// src/lib/pharmacyFirst/pathways/aht/_shared/foundayo-never-restart.ts
//
// PGD v2.1 (Stopping): "Discontinue and do not restart if acute pancreatitis is confirmed."
// The pathway cannot read saved reviews itself, so the host registers a lookup by patient id.

type Lookup = (patientId: string) => boolean;

let lookup: Lookup | null = null;

export function registerFoundayoNeverRestartLookup(fn: Lookup | null): void {
  lookup = fn;
}

/** True when a saved review for this exact patient id recorded confirmed pancreatitis. Matched by id only, never by name. */
export function foundayoNeverRestartFor(patientId: unknown): boolean {
  if (typeof patientId !== "string" || patientId === "" || lookup === null) return false;
  return lookup(patientId);
}
